import { useForm } from "@tanstack/react-form"

import { Field } from "@/components/ui/Field"
import { Textarea } from "@/components/ui/Textarea"

interface AdditionalConsiderationsStepProps {
  value: string
  onChange: (value: string) => void
  onValidation?: (isValid: boolean) => void
}

export function AdditionalConsiderationsStep({
  value,
  onChange,
  onValidation,
}: AdditionalConsiderationsStepProps) {
  const form = useForm({
    defaultValues: {
      additionalConsiderations: value,
    },
  })

  return (
    <div className="tw-text-center tw-space-y-6 tw-pt-16">
      <h2 className="tw-text-3xl tw-pb-3 tw-font-bold tw-text-gray-800">
        Is there anything else to consider for this activity?
      </h2>

      <form.Field name="additionalConsiderations">
        {(field) => (
          <Field>
            <Textarea
              id={field.name}
              value={field.state.value}
              onBlur={() => {
                field.handleBlur()
                onChange(field.state.value)
                onValidation?.(true) // Always valid since it's optional
              }}
              onChange={(e) => {
                field.handleChange(e.target.value)
                onChange(e.target.value)
                onValidation?.(true) // Always valid since it's optional
              }}
              placeholder="e.g., Should match Texas state standards, focus on real-world examples..."
              rows={6}
              className="tw-w-full tw-max-w-3xl tw-mx-auto tw-px-6 tw-py-4 tw-border-2 tw-border-dashed tw-rounded-sm tw-text-center tw-text-base tw-text-gray-800 placeholder:tw-text-gray-400 placeholder:tw-whitespace-pre-line tw-transition-all tw-resize-none focus:tw-outline-none focus:tw-ring-2 tw-border-emerald-600 focus:tw-border-emerald-600 focus:tw-ring-emerald-600"
            />
          </Field>
        )}
      </form.Field>
    </div>
  )
}
